/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_Shortform_To_ListInputs */

const en_add_shortform_to_list = /** @type {(inputs: Add_Shortform_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Shortform To List`)
};

const fr_add_shortform_to_list = /** @type {(inputs: Add_Shortform_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter l'abréviation à la liste`)
};

const de_add_shortform_to_list = /** @type {(inputs: Add_Shortform_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurzform zur Liste hinzufügen`)
};

const it_add_shortform_to_list = /** @type {(inputs: Add_Shortform_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi abbreviazione all'elenco`)
};

const ru_add_shortform_to_list = /** @type {(inputs: Add_Shortform_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить короткую форму в список`)
};

const es_add_shortform_to_list = /** @type {(inputs: Add_Shortform_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar formato abreviado a la lista`)
};

const zh_cn2_add_shortform_to_list = /** @type {(inputs: Add_Shortform_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将缩写添加到列表`)
};

const ja_add_shortform_to_list = /** @type {(inputs: Add_Shortform_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リストにショートフォームを追加`)
};

const hi_add_shortform_to_list = /** @type {(inputs: Add_Shortform_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूची में संक्षिप्त रूप जोड़ें`)
};

const pt_pt2_add_shortform_to_list = /** @type {(inputs: Add_Shortform_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar abreviatura à lista`)
};

/**
* | output |
* | --- |
* | "Add Shortform To List" |
*
* @param {Add_Shortform_To_ListInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const add_shortform_to_list = /** @type {((inputs?: Add_Shortform_To_ListInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_Shortform_To_ListInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_add_shortform_to_list(inputs)
	if (locale === "de") return de_add_shortform_to_list(inputs)
	if (locale === "it") return it_add_shortform_to_list(inputs)
	if (locale === "ru") return ru_add_shortform_to_list(inputs)
	if (locale === "es") return es_add_shortform_to_list(inputs)
	if (locale === "zh-CN") return zh_cn2_add_shortform_to_list(inputs)
	if (locale === "ja") return ja_add_shortform_to_list(inputs)
	if (locale === "hi") return hi_add_shortform_to_list(inputs)
	if (locale === "pt-PT") return pt_pt2_add_shortform_to_list(inputs)
	return en_add_shortform_to_list(inputs)
});